import { createContext, ReactNode, useEffect, useState } from 'react';
import { AppointmentService } from 'services';
import { PetStateProps, Symptoms } from 'types';

type PetProviderProps = {
  children: ReactNode;
};

export type PetContextData = {
  pet: PetStateProps;
  petSymptoms: Symptoms[];
  treatmentQueueId: string | null;
  generalClassification: Symptoms['classification'] | null;
  setAppointmentOnHold: () => Promise<void>;
  getAppointmentOnContext: () => Promise<void>;
};

//FIXME: Verificar se mantém ou se remove esse arquivo
export const PetContext = createContext<PetContextData>({} as PetContextData);

export const PetProvider = ({ children }: PetProviderProps) => {
  const [pet, setPet] = useState<PetStateProps>({} as PetStateProps);
  const [treatmentQueueId, setTreatmentQueueId] = useState<string | null>(null);
  const [petSymptoms, setPetSymptoms] = useState<Symptoms[]>([]);
  const [generalClassification, setGeneralClassification] = useState<
    Symptoms['classification'] | null
  >(null);

  const getAppointmentOnContext = async () => {
    try {
      const { pet, symptoms, generalClassification, _id } =
        await AppointmentService.getAppointmentInfo();

      setTreatmentQueueId(_id);
      setPet(pet);
      setPetSymptoms(symptoms || []);
      setGeneralClassification(generalClassification);
    } catch (err) {}
  };

  const setAppointmentOnHold = async () => {
    try {
      await AppointmentService.setAppointmentOnHold();
      getAppointmentOnContext();
    } catch (err) {
      if (err instanceof Error) {
      }
    }
  };

  useEffect(() => {
    getAppointmentOnContext();
  }, []);

  return (
    <PetContext.Provider
      value={{
        treatmentQueueId,
        pet,
        petSymptoms,
        generalClassification,
        setAppointmentOnHold,
        getAppointmentOnContext,
      }}
    >
      {children}
    </PetContext.Provider>
  );
};

